module.exports = __webpack_public_path__ + "img/tick.83b197a1.svg";